const zIndexes = {
  OpaqueLayer: 10,
  AuthModal: 20,
  Toolbar: 5,
  Popup: 25,
  WriteFooter: 10,
  PublishScreen: 15,
  DragDropUpload: 100,
};

export default zIndexes;



// WEBPACK FOOTER //
// ./src/components/write/ToolBar/zIndexes.js